import { Typography, Box, Card,  } from "@mui/material"
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Trans } from "@lingui/macro";

export const CaptchaVerified = () => {
    return (
        <Box sx={{
            textAlign: "center",
            margin: "auto"
            }}>
            <MailOutlineIcon sx={{ width: "3rem", height: "3rem"}}/>
            <Typography variant="body1"><Trans>Please verify your profile by clicking on the verification link we have sent by email.</Trans></Typography>
        </Box>
    )
}